// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"2ca07805","878":"59708c2c"}[chunkId] + ".chunk.js";
};